import { render, staticRenderFns } from "./ManualOrderForm.vue?vue&type=template&id=24befe93"
import script from "./ManualOrderForm.vue?vue&type=script&lang=js"
export * from "./ManualOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports